import { createStore } from 'vuex'

export default createStore({
  state: { // 用来写要存储的状态（数据）
    ws:null,
    chooseInput:null,
    age: 16,
    loginCancel:false,
    sendFile:null,
  },
  getters: { // 相当于vue中的计算属性
    changeAge(state) {
      return state.age + '岁'
    },
    getLoginCancel(state){
      return state.loginCancel
    }
  },
  mutations: { // 修改state数据的唯一方法就是提交mutation
    changeWs(state, value) {
      state.ws = value
    },

    changeSendFile(state,value){
      state.sendFile = value
    },

    changeInput(state, value) {
      state.chooseInput = value
    },

    changeProducts(state, value=[]) {
      state.products = value
    },

    changeLoginCancel(state, value=[]) {
      state.loginCancel = value
    },
  },
  actions: { // 异步处理数据的方法 通过提交mutation修改数据 不建议直接修改 这里直接修改也可以 但是当前情况下框架不完善 所以不建议直接修改
    getProducts({commit}) {
      setTimeout(() => {
        commit('changeProducts', [{name: '这是一个商品'}])
      }, 1000)
    }
  },
  modules: { // 模块化方法
  },
  plugins: [] // 插件使用的位置
})
